import type { ModuleVersionGroup } from '../groupModulesByVersion';
import { DraggableModule } from './DraggableModule/DraggableModule';
import styles from './ModulesContainer.module.scss';

interface ModulesContainerProperties {
  nonSystemModules: ModuleVersionGroup[];
  systemModules: ModuleVersionGroup[];
}

export const ModulesContainer = ({
  nonSystemModules,
  systemModules,
}: ModulesContainerProperties) => {
  const hasNoModules =
    systemModules.length === 0 && nonSystemModules.length === 0;

  if (hasNoModules) {
    return (
      <div className={styles.modulesContainer}>
        <div className={styles.emptyState}>
          No modules found matching your search.
        </div>
      </div>
    );
  }

  return (
    <div className={styles.modulesContainer}>
      {nonSystemModules.length > 0 && (
        <div className={styles.moduleSection}>
          <h4 className={styles.sectionTitle}>
            Custom Modules ({nonSystemModules.length})
          </h4>
          {nonSystemModules.map((group) => (
            <DraggableModule key={group.latest.textId} group={group} />
          ))}
        </div>
      )}
      {systemModules.length > 0 && (
        <div className={styles.moduleSection}>
          <h4 className={styles.sectionTitle}>
            System Modules ({systemModules.length})
          </h4>
          {systemModules.map((group) => (
            <DraggableModule key={group.latest.textId} group={group} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ModulesContainer;

